import { propertyQueryKeys as e } from "./usePropertiesQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { unitsApi as n } from "@maat/api-main";
//#region src/properties/useUnitDetailQuery.ts
var r = (r) => t({
	queryKey: e.unit(r),
	queryFn: () => n.getUnit(r),
	enabled: !!r
});
//#endregion
export { r as useUnitDetailQuery };
